<template>
  <div class="app-container workspace">
    <!-- <el-button
      icon="el-icon-back"
      class="back"
      type="info"
      size="mini"
      plain
      @click="$router.push('/')"
      >返回主页
    </el-button> -->
    <el-tabs @tab-click="handleClick" v-model="activeName">
      <el-tab-pane label="审批列表" name="审批列表">
        <el-row style="margin-bottom: 20px">
          <el-col :xs="12" :sm="10" :md="8" :lg="6" :xl="4">
            <el-input
                size="medium"
                v-model="formList.name"
                placeholder="搜索模板"
                clearable
                @input="getSearch"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
        </el-row>
        <el-collapse v-model="actives" v-loading="loading">
          <el-collapse-item
              v-for="(group, index) in formList.list"
              :key="index"
              :name="group.name"
          >
            <template slot="title">
              <img :src="group.icon" alt="" class="icon"/>{{ group.name }}
            </template>
            <div>
              <div
                  v-for="(item, index) in group.tptList"
                  :key="index"
                  class="form-item"
                  @click="enterItem(item)"
              >
                <i
                    :class="item.Icon.icon"
                    :style="'background: ' + item.Icon.background"
                ></i>
                <div>
                  <ellipsis hover-tip :content="item.name"/>
                  <span>发起审批</span>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div>
          <div
              v-for="(item, index) in formList.searchResult"
              :key="index"
              class="form-item"
              @click="enterItem(item)"
          >
            <i :class="item.icon" :style="'background: ' + item.background"></i>
            <div>
              <span>{{ item.formName }}</span>
              <span>发起审批</span>
            </div>
          </div>
          <!-- <div
            class="no-data"
            v-show="formList.searchResult.length === 0 && formList.name !== ''"
          >
            没有找到相关的表单 😥
          </div> -->
        </div>
        <div class="no-data" v-show="formList.list.length == 0">
          暂无数据 😀
        </div>
      </el-tab-pane>
      <el-tab-pane label="待我处理" name="待我处理">
        <el-table
            v-loading="tableDataLoading"
            :data="tableData.list"
            style="width: 100%"
            height="630"
        >
          <el-table-column
              prop="customName"
              label="流程名称"
              width="200"
              show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
              prop="tptName"
              label="模板"
              width="200"
              show-overflow-tooltip
          />
          <el-table-column
              prop="tptGroupName"
              label="分组"
              width="160"
              show-overflow-tooltip
          />
          <el-table-column
              prop="applyTime"
              label="发起时间"
              width="180"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ parseTime(scope.row.applyTime) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="applyMan"
              label="发起人"
              width="150"
              show-overflow-tooltip
          />
          <!-- <el-table-column
            prop="activiteName"
            label="当前环节"
            width="120"
            show-overflow-tooltip
          /> -->
          <el-table-column label="状态" align="center" prop="StatusDesc">
            <template slot-scope="{ row }">
              <!-- <span
                style="color: #397aff"
                v-if="row.StatusDesc == '起草'"
                size="small"
                >{{ row.StatusDesc }}</span
              > -->
              <span
                  style="color: #67c23a"
                  v-if="row.status == 2"
                  type="warning"
                  size="small"
              >流转中</span
              >
              <span v-if="row.status == 9" type="small" size="small">结束</span>
            </template>
          </el-table-column>
          <el-table-column
              label="结果"
              align="center"
              prop="result"
              fixed="right"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.result == 1" size="small">审核中</el-tag>
              <el-tag v-if="row.result == 2" type="success" size="small"
              >完成
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '撤回'"
                type="info"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
              <el-tag v-if="row.result == 4" type="warning" size="small"
              >拒绝
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '退回'"
                type="danger"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                  type="warning"
                  size="mini"
                  @click="handleSuccess(scope.row)"
              >审批
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="toolbar" style="padding: 10px">
          <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getMyFlowInstancePage"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="我处理的" name="我处理的">
        <el-table
            v-loading="tableData2Loading"
            :data="tableData2.list"
            style="width: 100%"
            height="630"
        >
          <el-table-column
              prop="customName"
              label="流程名称"
              width="200"
              show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
              prop="tptName"
              label="模板"
              width="200"
              show-overflow-tooltip
          />
          <el-table-column
              prop="tptGroupName"
              label="分组"
              width="160"
              show-overflow-tooltip
          />
          <el-table-column
              prop="applyTime"
              label="发起时间"
              width="180"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ parseTime(scope.row.applyTime) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="applyMan"
              label="发起人"
              width="150"
              show-overflow-tooltip
          />
          <!-- <el-table-column
            prop="activiteName"
            label="当前环节"
            width="120"
            show-overflow-tooltip
          /> -->
          <el-table-column label="状态" align="center" prop="StatusDesc">
            <template slot-scope="{ row }">
              <!-- <span
                style="color: #397aff"
                v-if="row.StatusDesc == '起草'"
                size="small"
                >{{ row.StatusDesc }}</span
              > -->
              <span
                  style="color: #67c23a"
                  v-if="row.status == 2"
                  type="warning"
                  size="small"
              >流转中</span
              >
              <span v-if="row.status == 9" type="small" size="small">结束</span>
            </template>
          </el-table-column>
          <el-table-column
              label="结果"
              align="center"
              prop="result"
              fixed="right"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.result == 1" size="small">审核中</el-tag>
              <el-tag v-if="row.result == 2" type="success" size="small"
              >完成
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '撤回'"
                type="info"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
              <el-tag v-if="row.result == 4" type="warning" size="small"
              >拒绝
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '退回'"
                type="danger"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleSuccess2(scope.row)"
              >详情
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="toolbar" style="padding: 10px">
          <pagination
              v-show="total2 > 0"
              :total="total2"
              :page.sync="queryParams2.pageNum"
              :limit.sync="queryParams2.pageSize"
              @pagination="getMyFlowInstancePage2"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="我发起的" name="我发起的">
        <el-table
            v-loading="tableData3Loading"
            :data="tableData3.list"
            style="width: 100%"
            height="630"
        >
          <el-table-column
              prop="customName"
              label="流程名称"
              width="200"
              show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
              prop="tptName"
              label="模板"
              width="200"
              show-overflow-tooltip
          />
          <el-table-column
              prop="tptGroupName"
              label="分组"
              width="160"
              show-overflow-tooltip
          />
          <el-table-column
              prop="applyTime"
              label="发起时间"
              width="180"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ parseTime(scope.row.applyTime) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="applyMan"
              label="发起人"
              width="150"
              show-overflow-tooltip
          />
          <!-- <el-table-column
            prop="activiteName"
            label="当前环节"
            width="120"
            show-overflow-tooltip
          /> -->
          <el-table-column label="状态" align="center" prop="StatusDesc">
            <template slot-scope="{ row }">
              <!-- <span
                style="color: #397aff"
                v-if="row.StatusDesc == '起草'"
                size="small"
                >{{ row.StatusDesc }}</span
              > -->
              <span
                  style="color: #67c23a"
                  v-if="row.status == 2"
                  type="warning"
                  size="small"
              >流转中</span
              >
              <span v-if="row.status == 9" type="small" size="small">结束</span>
            </template>
          </el-table-column>
          <el-table-column
              label="结果"
              align="center"
              prop="result"
              fixed="right"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.result == 1" size="small">审核中</el-tag>
              <el-tag v-if="row.result == 2" type="success" size="small"
              >完成
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '撤回'"
                type="info"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
              <el-tag v-if="row.result == 4" type="warning" size="small"
              >拒绝
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '退回'"
                type="danger"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleSuccess2(scope.row)"
              >详情
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="toolbar" style="padding: 10px">
          <pagination
              v-show="total3 > 0"
              :total="total3"
              :page.sync="queryParams3.pageNum"
              :limit.sync="queryParams3.pageSize"
              @pagination="getMyFlowInstancePage3"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="抄送给我" name="抄送给我">
        <el-table
            v-loading="tableData4Loading"
            :data="tableData4.list"
            style="width: 100%"
            height="630"
        >
          <el-table-column
              prop="customName"
              label="流程名称"
              width="200"
              show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
              prop="tptName"
              label="模板"
              width="200"
              show-overflow-tooltip
          />
          <el-table-column
              prop="tptGroupName"
              label="分组"
              width="160"
              show-overflow-tooltip
          />
          <el-table-column
              prop="applyTime"
              label="发起时间"
              width="180"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ parseTime(scope.row.applyTime) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="applyMan"
              label="发起人"
              width="150"
              show-overflow-tooltip
          />
          <!-- <el-table-column
            prop="activiteName"
            label="当前环节"
            width="120"
            show-overflow-tooltip
          /> -->
          <el-table-column label="状态" align="center" prop="StatusDesc">
            <template slot-scope="{ row }">
              <!-- <span
                style="color: #397aff"
                v-if="row.StatusDesc == '起草'"
                size="small"
                >{{ row.StatusDesc }}</span
              > -->
              <span
                  style="color: #67c23a"
                  v-if="row.status == 2"
                  type="warning"
                  size="small"
              >流转中</span
              >
              <span v-if="row.status == 9" type="small" size="small">结束</span>
            </template>
          </el-table-column>
          <el-table-column
              label="结果"
              align="center"
              prop="result"
              fixed="right"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.result == 1" size="small">审核中</el-tag>
              <el-tag v-if="row.result == 2" type="success" size="small"
              >完成
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '撤回'"
                type="info"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
              <el-tag v-if="row.result == 4" type="warning" size="small"
              >拒绝
              </el-tag
              >
              <!-- <el-tag
                v-if="row.ResultDesc == '退回'"
                type="danger"
                size="small"
                >{{ row.ResultDesc }}</el-tag
              > -->
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleSuccess3(scope.row)"
              >详情
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="toolbar" style="padding: 10px">
          <pagination
              v-show="total4 > 0"
              :total="total4"
              :page.sync="queryParams4.pageNum"
              :limit.sync="queryParams4.pageSize"
              @pagination="getMyFlowInstancePage4"
          />
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 发起审批 弹框 -->
    <el-drawer
        title="发起审批"
        size="40%"
        :visible.sync="openItemDl"
        append-to-body
        class="editdrawer spDrawer"
        @close="Close"
    >
      <!-- style="top: 20px" -->
      <initiate-process
          ref="processForm"
          :typeName="typeName"
          :code="selectForm.tptId"
          v-if="openItemDl"
      ></initiate-process>

      <el-timeline style="margin: 50px 0px 0px">
        <el-timeline-item v-for="(i, index) in InitFlowNodeList" :key="index">
          <!-- :timestamp="i.addTime" -->
          {{ i.nodeName }} <span v-if="i.makers">- {{ i.makers }}</span>
          <!-- 单选 -->
          <el-dropdown
              style="float: right"
              trigger="click"
              @command="handleCommand"
              v-if="i.selectMode == 1"
          >
            <span class="el-dropdown-link">
              <el-button
                  @click="handelApproval"
                  v-if="i.nodeType == 'APPROVAL' && i.selfSelect == 1"
                  size="mini"
                  icon="el-icon-plus"
              ></el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                  v-for="j in i.AltUserList"
                  :key="j.id"
                  :command="j.id"
              >{{ j.name }}
              </el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 多选 -->
          <el-select
              style="width: 92%"
              size="mini"
              v-if="
              i.selectMode == 2 && i.nodeType == 'APPROVAL' && i.selfSelect == 1
            "
              v-model="ids"
              multiple
              placeholder="请选择审批人"
              @change="handleCommand1"
          >
            <el-option
                v-for="j in i.AltUserList"
                :key="j.id"
                :label="j.name"
                :value="j.id"
            />
          </el-select>
        </el-timeline-item>
      </el-timeline>
      <div
          class="demo-drawer__footer"
          style="text-align: center; margin: 30px 0 0px"
      >
        <el-button @click="Close">取 消</el-button>
        <el-button type="primary" @click="submitForm">提 交</el-button>
      </div>
    </el-drawer>

    <!-- 审批 弹窗 -->
    <!-- style="top: 20px" -->
    <el-drawer
        title="审批详情"
        :visible.sync="drawer"
        destroy-on-close
        class="shenpi"
        size="35%"
        append-to-body
        @close="cancel"
    >
      <el-descriptions class="title" :column="2">
        <el-descriptions-item label="流程名称">
          {{ shenPiList.customName }}
        </el-descriptions-item>
        <el-descriptions-item label="模板名称">
          {{ shenPiList.tptName }}
        </el-descriptions-item>
        <el-descriptions-item label="模板分组">
          {{ shenPiList.tptGroupName }}
        </el-descriptions-item>

        <el-descriptions-item label="发起人">
          {{ shenPiList.applyMan }}
        </el-descriptions-item>
        <el-descriptions-item label="发起时间">
          {{ shenPiList.applyTime }}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="当前节点">
          <el-tag size="small">{{ shenPiList.activiteName }}</el-tag>
        </el-descriptions-item> -->
        <!-- <el-descriptions-item label="节点类型">
          {{ shenPiList.ActiviteTypeDesc }}
        </el-descriptions-item> -->
      </el-descriptions>
      <!-- 制证申请 -->
      <div class="form" v-if="shenPiList.TptGroupId == 'TG_MakeCard'">
        <el-form ref="form" :model="MakeCardList" label-width="120px">
          <el-form-item label="护照号" prop="Passport">
            <el-input
                v-model="MakeCardList.Passport"
                placeholder="请输入护照号"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="药物过敏史" prop="Allergy">
            <el-input
                v-model="MakeCardList.Allergy"
                placeholder="请输入药物过敏史"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="紧急联系人" prop="TouchMan">
            <el-input
                v-model="MakeCardList.TouchMan"
                placeholder="请输入紧急联系人"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="紧急联系电话" prop="TouchTel">
            <el-input
                v-model="MakeCardList.TouchTel"
                placeholder="请输入紧急联系电话"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="收件人" prop="Recipient">
            <el-input
                v-model="MakeCardList.Recipient"
                placeholder="请输入收件人"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="收件人联系电话" prop="RecMobile">
            <el-input
                v-model="MakeCardList.RecMobile"
                placeholder="请输入收件人联系电话"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="收件地址" prop="RecAddr">
            <el-input
                v-model="MakeCardList.RecAddr"
                placeholder="请输入收件地址"
                :readonly="true"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 转正申请 -->
      <div class="form" v-if="shenPiList.TptGroupId == 'TG_TMUpgrade'">
        <el-form ref="form" :model="ApplyList" label-width="120px">
          <el-form-item label="姓名" prop="Name">
            <el-input
                v-model="ApplyList.Name"
                placeholder="请输入姓名"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="蓝天编号" prop="Code">
            <el-input
                v-model="ApplyList.Code"
                placeholder="请输入蓝天编号"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="身份证号" prop="IdCard">
            <el-input
                v-model="ApplyList.IdCard"
                placeholder="请输入身份证号"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="附件" prop="Annex">
            <file-upload
                v-model="ApplyList.Annex"
                :isShowTip="false"
                :isShowDel="false"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 自定义申请 -->
      <div class="form" v-if="Show">
        <initiate-process1
            ref="processForm"
            :flag="flag"
            :code="shenPiList.tptId"
            :forms="formData"
            :formPerms="JSON.parse(shenPiList.formPerms)"
        ></initiate-process1>
      </div>

      <div class="form">
        <el-timeline style="margin: 20px 0">
          <el-timeline-item
              v-for="(i, index) in processList"
              :key="index"
              :timestamp="i.addTime"
          >
            {{ i.content }}
            <a v-if="i.attacth" :href="i.attacth">点击下载附件</a>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="form" v-if="buttonShow">
        <div style="margin-top: 10px">审批</div>
        <el-form
            ref="dataForm"
            :model="dataForm"
            label-width="120px"
            :rules="dataFormRules"
            label-position="right"
            class="demo-form-inline"
            :inline="true"
            size="mini"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="审批意见" prop="verifyIdea">
                <el-input
                    v-model="dataForm.verifyIdea"
                    type="textarea"
                    autosize
                    style="width: 170%"
                    auto-complete="off"
                    placeholder="请输入审批意见"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件" prop="attacth">
                <file-upload v-model="dataForm.attacth" :isShowTip="false"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
            class="demo-drawer__footer"
            style="text-align: center; margin: 60px 0 20px"
            v-if="buttonShow"
        >
          <!-- <el-button @click.native="cancel">关闭</el-button> -->
          <!-- :loading="editLoading" -->
          <el-button type="success" @click.native="ceasepost(1)"
          >同意
          </el-button
          >
          <!-- :loading="editLoading" -->
          <el-button type="warning" @click.native="ceasepost(2)"
          >不同意
          </el-button
          >
          <!-- <el-button
            :loading="editLoading"
            type="danger"
            @click.native="ceasepost(3)"
            >驳回</el-button
          > -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getFormGroups,
  SubmitInstance,
  GetFlowInstancePage,
  GetFlowInstance,
  GetFlowInstanceCC,
  VerifyInstance,
  GetOpeateRecList,
  ExistInstance,
  GenerateInstance,
  InitFlowNode,
  SetCustomVerifiy,
  GetMakeCard,
  GetChangeApply,
  GetApply,
} from "@/api/design";
import InitiateProcess1 from "./InitiateProcess1";
import InitiateProcess from "./InitiateProcess";
import Pagination from "@/components/Pagination";

export default {
  name: "workSpace",
  components: {InitiateProcess1, InitiateProcess, Pagination},
  data() {
    return {
      typeName: '',
      flag: "",
      MakeCardList: {},
      ApplyList: {},
      ids: "",
      AltUserList: [],
      processList: [],
      queryParams4: {
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
        userId: this.$route.query.userId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams3: {
        userId: this.$route.query.userId,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams2: {
        userId: this.$route.query.userId,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams: {
        userId: this.$route.query.userId,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      total: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      instanceId: "",
      activiteId: "",
      editLoading: false,
      dataForm: {
        userId: this.$route.query.userId,
        nickName: this.$route.query.nickName,
      },
      dataFormRules: {
        Status: [
          {required: true, message: "审核结果不能为空", trigger: "change"},
        ],
      },
      activities: [],
      Show: false,
      formData: [],
      shenPiList: {}, // 审批详情
      drawer: false,
      InitFlowNodeList: [],
      activeName: "审批列表",
      buttonShow: true,
      tableData: {},
      tableData2: {},
      tableData3: {},
      tableData4: {},
      loading: false,
      tableDataLoading: false,
      tableData2Loading: false,
      tableData3Loading: false,
      tableData4Loading: false,
      tptId: "",
      openItemDl: false,
      selectForm: {},
      formItem: {},
      actives: [],
      formList: {
        list: [],
        name: "",
        searchResult: [],
      },
      pending: {
        list: [],
      },
    };
  },
  mounted() {
    this.getGroups();
  },
  methods: {
    handelApproval() {
    },
    // 审批
    handleSuccess(row) {
      console.log(row);
      this.activiteId = row.activiteId;
      this.instanceId = row.instanceId;
      this.drawer = true;
      this.buttonShow = true;
      // 获取审批详情
      GetFlowInstance({instanceId: row.instanceId}).then((res) => {
        this.shenPiList = res.data;
        if (res.data.TptGroupId == "TG_MakeCard") {
          // 制证 => 获取制证表单详情
          GetMakeCard({makeId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.MakeCardList = res.data;
            }
          });
        }
        if (res.data.TptGroupId == "TG_TMUpgrade") {
          // 转正申请 => 获取转正申请表单详情
          GetChangeApply({memberId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.ApplyList = res.data;
            }
          });
        }
        this.formData = JSON.parse(this.shenPiList.formData);
        // this.formData = eval("(" + this.shenPiList.formData + ")");
        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      // 获取审批进度
      GetOpeateRecList({instanceId: row.instanceId}).then((res) => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      });
    },
    // 获取审批记录详情
    handleSuccess2(row) {
      this.drawer = true;
      this.buttonShow = false;
      GetFlowInstance({instanceId: row.instanceId}).then((res) => {
        this.shenPiList = res.data;
        if (res.data.TptGroupId == "TG_MakeCard") {
          // 制证 => 获取制证表单详情
          GetMakeCard({makeId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.MakeCardList = res.data;
            }
          });
        }
        if (res.data.TptGroupId == "TG_TMUpgrade") {
          // 转正申请 => 获取转正申请表单详情
          GetApply({memberId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.ApplyList = res.data;
            }
          });
        }
        this.formData = JSON.parse(this.shenPiList.formData);

        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      GetOpeateRecList({instanceId: row.instanceId}).then((res) => {
        this.processList = res.data;
      });
    },
    // 获取审批记录详情(抄送给我)
    handleSuccess3(row) {
      this.drawer = true;
      this.buttonShow = false;
      GetFlowInstanceCC({
        instanceId: row.instanceId,
        userId: this.$route.query.userId,
      }).then((res) => {
        this.shenPiList = res.data;
        if (res.data.TptGroupId == "TG_MakeCard") {
          // 制证 => 获取制证表单详情
          GetMakeCard({makeId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.MakeCardList = res.data;
            }
          });
        }
        if (res.data.TptGroupId == "TG_TMUpgrade") {
          // 转正申请 => 获取转正申请表单详情
          GetApply({memberId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.ApplyList = res.data;
            }
          });
        }
        this.formData = JSON.parse(this.shenPiList.formData);

        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      GetOpeateRecList({instanceId: row.instanceId}).then((res) => {
        this.processList = res.data;
      });
    },
    ceasepost(val) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.dataForm.instanceId = this.instanceId;
          this.dataForm.activiteId = this.activiteId;
          this.dataForm.verifyFlag = val;
          this.formData.forEach((i) => {
            i.value = this.$store.state.formValue[i.id];
          });
          this.dataForm.formData = JSON.stringify(this.formData);
          console.log(this.dataForm, "dataForm");
          this.editLoading = true;
          VerifyInstance(this.dataForm).then((res) => {
            this.editLoading = false;
            if (res.code === 200) {
              this.$message({message: "操作成功", type: "success"});
              this.getMyFlowInstancePage();
              this.$refs["dataForm"].resetFields();
              this.cancel();
            } else {
              this.$message({message: "操作失败, " + res.msg, type: "error"});
            }
          });
        }
      });
    },
    cancel() {
      this.drawer = false;
      this.shenPiList = {};
      this.Show = false;
      this.dataForm = {
        instanceId: null,
        verifyFlag: null,
        activiteId: null,
        verifyIdea: null,
        attacth: null,
        userId: this.$route.query.userId,
        nickName: this.$route.query.nickName,
      };
    },
    handleClick(tab) {
      console.log(tab);
      if (tab.name == "审批列表") {
        this.flag = "";
        this.tableDataLoading = true;
        this.getGroups();
      }
      if (tab.name == "待我处理") {
        this.queryParams.flag = 1;
        this.flag = 1;
        this.tableDataLoading = true;
        this.getMyFlowInstancePage();
      }
      if (tab.name == "我处理的") {
        this.tableData2Loading = true;
        this.queryParams2.flag = 2;
        this.flag = 2;
        this.getMyFlowInstancePage2();
      }
      if (tab.name == "我发起的") {
        this.tableData3Loading = true;
        this.queryParams3.flag = 3;
        this.flag = 3;
        this.getMyFlowInstancePage3();
      }
      if (tab.name == "抄送给我") {
        this.tableData4Loading = true;
        this.queryParams4.flag = 4;
        this.flag = 4;
        this.getMyFlowInstancePage4();
      }
    },
    // 获取待我处理 列表
    async getMyFlowInstancePage() {
      const res = await GetFlowInstancePage(this.queryParams);
      this.tableData = res.data;
      this.total = res.data.total;
      this.tableDataLoading = false;
    },
    // 获取待我处理 列表
    async getMyFlowInstancePage2() {
      const res = await GetFlowInstancePage(this.queryParams2);
      this.tableData2 = res.data;
      this.total2 = res.data.total;
      this.tableData2Loading = false;
    },
    async getMyFlowInstancePage3() {
      const res = await GetFlowInstancePage(this.queryParams3);
      this.tableData3 = res.data;
      this.total3 = res.data.total;
      this.tableData3Loading = false;
    },
    async getMyFlowInstancePage4() {
      const res = await GetFlowInstancePage(this.queryParams4);
      this.tableData4 = res.data;
      this.total4 = res.data.total;
      this.tableData4Loading = false;
    },
    getSearch() {
      clearTimeout(this.timer);
      this.loading = true;
      this.timer = setTimeout(() => {
        this.getGroups();
      }, 1000);
    },
    getGroups() {
      this.loading = true;
      getFormGroups({
        name: this.formList.name,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((rsp) => {
        this.formList.list = rsp.data;
        this.formList.list.forEach((group) => {
          this.actives.push(group.name);
          group.tptList.forEach((item) => {
            item.Icon = JSON.parse(item.logo);
          });
        });
        this.groups = rsp.data;
        this.loading = false;
      });
      // .catch((err) => this.$message.error("获取分组异常"));
    },
    Close() {
      this.openItemDl = false;
      this.ids = "";
    },
    enterItem(item) {
      this.selectForm = item;
      this.typeName = item.name;
      this.tptId = item.tptId;
      this.initFlowNode(item.tptId);
      //   // 1. 判断是否存在起草中的示例
      //   ExistInstance({ tptId: item.tptId }).then((res) => {
      //     if (res.code == 200) {
      //       console.log(res.instanceId, "实例id---存在的");
      //       if (res.instanceId) {
      //         // 存在
      //         this.initFlowNode(res.instanceId);
      //       } else {
      //         // 不存在 => 生成实例
      //         GenerateInstance({ tptId: item.tptId }).then((res) => {
      //           if (res.code == 200) {
      //             console.log(res.data, "实例id---生成的");
      //             this.initFlowNode(res.data);
      //           }
      //         });
      //       }
      //     }
      //   });
    },
    // 2.初始化并加载审批节点(进度流程)
    initFlowNode(val) {
      console.log(val);
      this.instanceId = val;
      InitFlowNode({tptId: val}).then((res) => {
        if (res.code == 200) {
          console.log(res.data, "进度流程");
          this.InitFlowNodeList = res.data;
          this.InitFlowNodeList.forEach((i) => {
            if (i.selfSelect == 1) {
              // 自选 =>设置自选审批人
              this.AltUserList = i.AltUserList;
              // SetCustomVerifiy({ instanceId: val }).then((res) => {
              //   if (res.code == 200) {
              //     console.log(res.data, "自选审批人");
              //   }
              // });
            }
          });
          this.openItemDl = true;
        }
      });
    },
    handleCommand(val) {
      console.log(val);
      this.AltUserList.forEach((i) => {
        if (i.id == val) {
          console.log(i.name);
          this.InitFlowNodeList.forEach((j) => {
            if (j.nodeType == "APPROVAL" && j.selfSelect == 1) {
              console.log(j);
              j.MakerIds = i.id;
              j.makers = i.name;
            }
          });
        }
      });
    },
    handleCommand1() {
      var arr = [];
      this.InitFlowNodeList.forEach((j) => {
        if (j.nodeType == "APPROVAL" && j.selfSelect == 1) {
          console.log();
          arr = j.AltUserList;
        }
      });
      console.log(arr, "arr");
      console.log(this.ids, "ids");
      var Names = [];
      var Ids = [];
      this.ids.forEach((i) => {
        arr.forEach((j) => {
          if (j.id == i) {
            console.log(j.name);
            Names.push(j.name);
            Ids.push(j.id);
          }
        });
      });
      console.log(Names);
      console.log(Ids);
      this.InitFlowNodeList.forEach((j) => {
        if (j.nodeType == "APPROVAL" && j.selfSelect == 1) {
          j.MakerIds = Ids + "";
          j.makers = Names + "";
        }
      });
      console.log(this.InitFlowNodeList, "this.InitFlowNodeList");
    },
    submitForm() {
      let datas = document.getElementsByName("totalAmount");
      this.$refs.processForm.validate((valid) => {
        if (valid) {
          if (this.InitFlowNodeList.length > 0) {
            console.log(this.$store.state.formValue);
            var formItems = this.$store.state.design.formItems;
            console.log(formItems, "formItems");
            for (let i = 0; i < formItems.length; i++) {
              const e = formItems[i];
              e.value = this.$store.state.formValue[e.id];
            }
            console.log(this.$store.state.design.formItems);

            // return;
            for (var i = 0; i < this.InitFlowNodeList.length; i++) {
              if (
                  this.InitFlowNodeList[i].nodeType == "APPROVAL" &&
                  this.InitFlowNodeList[i].MakerIds == ""
              ) {
                this.$message({
                  message: "请选择审批人",
                  type: "warning",
                });
                return false;
              }
            }
            let params = {
              userId: this.$route.query.userId,
              nickName: this.$route.query.nickName,
              companyId: this.$route.query.EId,
              platformId: this.$route.query.platformId,
              instanceId: this.instanceId,
              flag: 2,
              flowNodes: JSON.stringify(this.InitFlowNodeList),
              tptId: this.tptId,
              formData: JSON.stringify(this.$store.state.design.formItems),
            }
            if (datas.length > 0) {
              params = {
                totalAmount: datas[0].ariaValueNow,
                userId: this.$route.query.userId,
                nickName: this.$route.query.nickName,
                companyId: this.$route.query.EId,
                platformId: this.$route.query.platformId,
                instanceId: this.instanceId,
                flag: 2,
                flowNodes: JSON.stringify(this.InitFlowNodeList),
                tptId: this.tptId,
                formData: JSON.stringify(this.$store.state.design.formItems),
              }
            }
            SubmitInstance(params).then((res) => {
              if (res.code === 200) {
                this.$message({message: "发起成功", type: "success"});
                this.openItemDl = false;
                this.$refs["processForm"].resetFields();
                this.getGroups();
              } else {
                this.$message({
                  message: "操作失败, " + res.msg,
                  type: "error",
                });
              }
            });
          } else {
            this.$message.warning("请先完善审批流程😥");
          }
        } else {
          this.$message.warning("请完善表单😥");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.workspace {
  // padding: 15px 0px;
  position: relative;

  .back {
    position: absolute;
    left: 20px;
    top: 13px;
  }

  .no-data {
    text-align: center;
    padding: 50px 0;
    color: #656565;
    margin: 0 auto;
  }

  /deep/ .el-collapse {
    padding: 0 15px;
    background: #ffffff;

    .el-collapse-item__header {
      font-size: medium;
    }

    .el-collapse-item__wrap {
      padding: 20px 10px;
    }

    .el-tabs--border-card .el-tabs__content {
      padding: 40px 15px;
    }
  }

  .form-item {
    padding: 15px 10px;
    width: 222px;
    cursor: pointer;
    border: 1px solid #d9dada;
    border-radius: 5px;
    float: left;
    margin: 5px 10px;
    // height: 69px;

    &:hover {
      border: 1px solid #448ed7;

      span {
        display: inline-block !important;
      }
    }

    i {
      padding: 8px;
      border-radius: 8px;
      float: left;
      font-size: 20px;
      color: #ffffff;
      background: #38adff;
      //   height: 36px;
      line-height: 20px;
    }

    div {
      height: 35px;
      line-height: 35px;

      div {
        display: inline-block;
        margin-left: 10px;
        width: 100px;
      }

      span {
        display: none;
        float: right;
        color: #38adff;
        font-size: 12px;
      }
    }

    /*span:nth-child(1) {
        float: left;
        margin: 5px 0 0 10px;
      }*/
    /*span:nth-child(1) {
        float: right;
        color: #448ed7;
        font-size: x-small;
        margin: 5px 0 5px 0;
      }*/
  }
}

@media screen and (max-width: 800px) {
  .form-item {
    padding: 12px 10px !important;
    width: 150px !important;
    margin: 5px !important;

    &:hover {
      span:last-child {
        display: none !important;
      }
    }
  }
}

.icon {
  display: block;
  width: 33px;
  height: 33px;
  vertical-align: middle;
  margin-right: 10px;
  border-radius: 10px;
}

.spDrawer /deep/ .el-input {
  width: 100% !important;
}

.shenpi /deep/ .el-drawer__body {
  background-color: #eee;
}

.shenpi /deep/ .el-drawer__body {
  padding: 0;
}

.shenpi /deep/ .el-drawer__header {
  margin-bottom: 32px;
}

.shenpi .title {
  padding: 0 25px;
  background: #ffffff;
}

.shenpi .form {
  margin-top: 15px;
  background: #fff;
  padding: 10px 25px;
}

.el-timeline-item {
  padding-bottom: 50px;
}

/deep/ .el-timeline-item__tail {
  border-left: 2px solid #397affbf;
}

/deep/ .el-timeline-item__node {
  background-color: #397aff;
}

.el-select /deep/ .el-input__inner {
  border: none !important;
}
</style>
